<template>
  <input
    v-maska
    data-maska="##:##"
    class="text-base font-normal text-primary placeholder:text-placeholder bg-transparent border-none focus:ring-0"
    :class="{ 'opacity-60 cursor-not-allowed select-none': disabled }"
    type="text"
    maxlength="5"
    size="5"
    :id="id"
    :name="name"
    :value="props.modelValue"
    :placeholder="placeholder"
    :disabled="disabled"
    @maska="handleInput"
    @blur="handleBlur"
  />
</template>

<script setup>
import { vMaska } from "maska";

const emit = defineEmits(["update:modelValue"]);

const props = defineProps({
  id: { type: String, required: true },
  modelValue: { type: String, required: true },
  name: { type: String, required: false },
  placeholder: { type: String, default: "00:00" },
  disabled: { type: Boolean, default: false },
});

function handleInput(e) {
  const { masked } = e.detail;
  let [hours, minutes] = masked.split(":");

  if (!minutes) {
    if (hours > 2 && hours < 10 && hours.length < 2) {
      return emit("update:modelValue", `0${hours}:`);
    }

    if (hours > 23) {
      hours = 23;
    }

    return emit("update:modelValue", `${hours}:`);
  }

  if (minutes > 5 && minutes < 10 && minutes.length < 2) {
    return emit("update:modelValue", `${hours}:0${minutes}`);
  }

  if (hours > 59) {
    hours = 59;
  }

  return emit("update:modelValue", `${hours}:${minutes}`);
}

function handleBlur() {
  let [hours, minutes] = props.modelValue.split(":");

  if (hours.length < 2) {
    hours = `0${hours}`;
  }

  if (hours == 0) {
    emit("update:modelValue", `00:00`);
    return;
  }

  if (minutes == 0) {
    emit("update:modelValue", `${hours}:00`);
    return;
  }

  if (minutes.length < 2) {
    emit("update:modelValue", `${hours}:0${minutes}`);
  }
}
</script>
